import React from "react";
import ImageUploadField from "./ImageUploadField";

function Field({ label, children, col = "col-md-6" }) {
    return (
        <div className={col}>
            <label className="form-label small">{label}</label>
            {children}
        </div>
    );
}

/*
  "Contact Section & Office" — what sits on the public site's Contact area
  and footer besides the donation QR: the appointment card heading and the
  personal-secretary / office contact card.
*/
export default function PoliticalContactTab({ form, set, secretary, setSecretary, personaluid }) {
    const setSec = (k, v) => setSecretary((s) => ({ ...s, [k]: v }));
    const secInput = (k, extra = {}) => (
        <input className="form-control form-control-sm" value={secretary[k] || ""} onChange={(e) => setSec(k, e.target.value)} {...extra} />
    );

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Appointment Card</div>
                <div className="card-body">
                    <div className="row g-3">
                        <Field label="Heading under “Request Appointment” (e.g. “Prime Minister Office”)">
                            <input className="form-control form-control-sm" value={form.office_title || ""} onChange={(e) => set("office_title", e.target.value)} />
                        </Field>
                        <Field label="कार्यालयको नाम (Nepali)">
                            <input className="form-control form-control-sm" placeholder="प्रधानमन्त्री कार्यालय" value={form.office_title_np || ""} onChange={(e) => set("office_title_np", e.target.value)} />
                        </Field>
                    </div>
                    <small className="form-text text-muted mt-2 d-block">
                        The phone number and email shown in the top bar and footer come from the <b>Profile</b> tab.
                    </small>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">
                    Personal Secretary / Office Contact <span className="text-muted fw-normal small">(shown in the footer)</span>
                </div>
                <div className="card-body">
                    <div className="row g-3">
                        <Field label="Name">{secInput("name")}</Field>
                        <Field label="नाम (Nepali)">{secInput("name_np")}</Field>
                        <Field label="Role">{secInput("title", { placeholder: "Personal Secretary" })}</Field>
                        <Field label="भूमिका (Nepali)">{secInput("title_np", { placeholder: "व्यक्तिगत सचिव" })}</Field>
                        <Field label="Phone">{secInput("phone")}</Field>
                        <Field label="Email">{secInput("email", { type: "email" })}</Field>
                        <Field label="Photo">
                            <ImageUploadField value={secretary.photo || ""} onChange={(v) => setSec("photo", v)} purpose="logo" personaluid={personaluid} placeholder="Upload photo" />
                        </Field>
                    </div>
                    <small className="form-text text-muted mt-2 d-block">The card only appears once a name is entered.</small>
                </div>
            </div>
        </div>
    );
}